import React from "react";
import Common_Title from "../common_components/common_title/Common_Title";
import { Container } from "react-bootstrap";
import "./Privacy_Policy.css";

const Privacy_Policy = () => {
  return (
    <section className="common_section">
      <Container>
        <div className="terms_header">
          <Common_Title darkText={"Privacy Policy"} />
        </div>

        <div className="terms_content">

          {/* 1. INTRODUCTION */}
          <div className="terms_item">
            <h3 className="terms_head">1. INTRODUCTION</h3>
            <p className="terms_description">
              PROFCYMACRM built the Profcyma app as a Free app. This SERVICE is
              provided by PROFCYMACRM at no cost and is intended for use as is.
              This page is used to inform visitors regarding our policies with 
              the collection, use, and disclosure of Personal Information if 
              anyone decides to use our Service.
              <br /><br />
              By using our Service, you agree to the collection and use of 
              information in accordance with this policy. The Personal 
              Information we collect is used to provide and improve the 
              Service. We do not use or share your information with anyone 
              except as described in this Privacy Policy.
              <br /><br />
              Terms used in this Privacy Policy have the same meanings as in 
              our Terms and Conditions, which are accessible through the 
              Profcyma app unless otherwise defined.
            </p>
          </div>

          {/* 2. INFORMATION COLLECTION AND USE */}
          <div className="terms_item">
            <h3 className="terms_head">2. INFORMATION COLLECTION AND USE</h3>
            <p className="terms_description">
              For a better experience, while using our Service, we may require 
              you to provide certain personally identifiable information, 
              including but not limited to your name, email, and phone number. 
              This information is retained and used as described in this 
              Privacy Policy.
              <br /><br />
              The app uses third-party services that may collect information 
              used to identify you. You are advised to review the privacy 
              policies of these third-party service providers.
            </p>
          </div>

          {/* 3. PERMISSIONS WE REQUEST */}
          <div className="terms_item">
            <h3 className="terms_head">3. PERMISSIONS WE REQUEST</h3>
            <p className="terms_description">
              In accordance with Google Play Store policies, the Profcyma app 
              may request access to the following permissions:
              <br /><br />
              <b>• Location:</b> Used to provide location-specific content or functionality.
              <br />
              <b>• Read Call Logs:</b> Used exclusively to automatically detect 
              incoming and outgoing client calls to help users log call 
              interactions within the CRM. This data is not shared with any 
              third party.
              <br />
              <b>• Phone State (READ_PHONE_STATE):</b> Used to detect call 
              status for automatic lead logging and efficient CRM record keeping.
              <br />
              <b>• Phone Calls:</b> Used to initiate calls directly from the app.
              <br />
              <b>• Notifications:</b> Used to send important alerts & updates.
              <br />
              <b>• Calendar:</b> Used to read or manage events for scheduling.
              <br />
              <b>• Overlay Permission:</b> Required for chat support or floating widgets.
              <br /><br />
              You may manage or revoke permissions anytime from device settings. 
              Disabling certain permissions may limit app functionality.
            </p>
          </div>

          {/* 4. LOG DATA */}
          <div className="terms_item">
            <h3 className="terms_head">4. LOG DATA</h3>
            <p className="terms_description">
              In case of an error in the app, we collect data and information 
              (through third-party products) on your phone called Log Data. 
              This may include your device’s IP address, device name, operating 
              system version, app configuration, time and date of use, and 
              other statistics.
            </p>
          </div>

          {/* 5. COOKIES */}
          <div className="terms_item">
            <h3 className="terms_head">5. COOKIES</h3>
            <p className="terms_description">
              This Service does not use cookies directly. However, third-party 
              libraries used by the app may use cookies to collect information 
              and improve their services. You may accept or decline cookies 
              from device settings.
            </p>
          </div>

          {/* 6. SERVICE PROVIDERS */}
          <div className="terms_item">
            <h3 className="terms_head">6. SERVICE PROVIDERS</h3>
            <p className="terms_description">
              We may employ third-party companies and individuals to:
              <br />
              • Facilitate our Service <br />
              • Provide services on our behalf <br />
              • Perform Service-related tasks <br />
              • Assist us in analyzing app usage
              <br /><br />
              These third parties may have access to your Personal Information 
              only to perform tasks on our behalf and are obligated not to 
              disclose or use it for any other purpose.
            </p>
          </div>

          {/* 7. SECURITY */}
          <div className="terms_item">
            <h3 className="terms_head">7. SECURITY</h3>
            <p className="terms_description">
              We value your trust in providing your Personal Information and use 
              commercially acceptable measures to protect it. However, no method 
              of electronic transmission or storage is 100% secure, and we 
              cannot guarantee absolute protection.
            </p>
          </div>

          {/* 8. LINKS TO OTHER SITES */}
          <div className="terms_item">
            <h3 className="terms_head">8. LINKS TO OTHER SITES</h3>
            <p className="terms_description">
              This Service may contain links to third-party websites. We do not 
              operate these sites and strongly advise you to review their 
              Privacy Policies. We assume no responsibility for the content or 
              practices of external websites.
            </p>
          </div>

          {/* 9. CHILDREN'S PRIVACY */}
          <div className="terms_item">
            <h3 className="terms_head">9. CHILDREN'S PRIVACY</h3>
            <p className="terms_description">
              Our Services do not address anyone under the age of 13. We do not 
              knowingly collect personal information from children. If you 
              believe a child under 13 has provided us with personal 
              information, please contact us immediately.
            </p>
          </div>

          {/* 10. CHANGES TO THIS PRIVACY POLICY */}
          <div className="terms_item">
            <h3 className="terms_head">10. CHANGES TO THIS PRIVACY POLICY</h3>
            <p className="terms_description">
              We may update our Privacy Policy periodically. You are advised to 
              review this page regularly for any changes. Updates are effective 
              immediately once posted.
            </p>
          </div>

          {/* 11. CONTACT US */}
          <div className="terms_item">
            <h3 className="terms_head">11. CONTACT US</h3>
            <p className="terms_description">
              If you have any questions or suggestions regarding our Privacy 
              Policy, please contact us.
            </p>
          </div>

        </div>
      </Container>
    </section>
  );
};

export default Privacy_Policy;
